import React, { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';

export interface DpOutlinedOTPInputProps {
	value?: string;
	otpLength?: number;
	onChange?: (otp: string[]) => void;
}

export const DpOutlinedOTPInput: React.FC<DpOutlinedOTPInputProps> = ({
	value = '',
	otpLength = 6,
	onChange,
}) => {
	const [otp, setOtp] = useState<string[]>(
		Array.from({ length: otpLength }, (_, i) => value[i] || '')
	);
	const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

	useEffect(() => {
		setOtp(Array.from({ length: otpLength }, (_, i) => value[i] || ''));
	}, [value, otpLength]);

	const handleChange = (index: number, val: string) => {
		if (!/^\d?$/.test(val)) return;

		const updatedOtp = [...otp];
		updatedOtp[index] = val;
		setOtp(updatedOtp);

		if (val && index < otpLength - 1) {
			inputsRef.current[index + 1]?.focus();
		}

		onChange?.(updatedOtp);
	};

	const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Backspace') {
			if (otp[index]) {
				const updatedOtp = [...otp];
				updatedOtp[index] = '';
				setOtp(updatedOtp);
				onChange?.(updatedOtp);
			} else if (index > 0) {
				inputsRef.current[index - 1]?.focus();
			}
		}
	};

	return (
		<Box display="flex" gap={1} alignItems="center" justifyContent="center">
			{otp.map((digit, index) => (
				<DpOutlinedInput
					key={index}
					inputRef={(el) => (inputsRef.current[index] = el)}
					value={digit}
					onChange={(e) => handleChange(index, e.target.value)}
					onKeyDown={(e) => handleKeyDown(index, e as any)}
					inputProps={{
						maxLength: 1,
						inputMode: 'numeric',
						pattern: '[0-9]*',
						style: {
							textAlign: 'center',
							fontSize: '1.5rem',
							width: '3rem',
							height: '35px',
						},
					}}
					variant="outlined"
					size="small"
				/>
			))}
		</Box>
	);
};
